import { render, staticRenderFns } from "./sorting.vue?vue&type=template&id=fa23c91c&scoped=true"
import script from "./sorting.vue?vue&type=script&lang=js"
export * from "./sorting.vue?vue&type=script&lang=js"
import style0 from "./sorting.vue?vue&type=style&index=0&id=fa23c91c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa23c91c",
  null
  
)

export default component.exports